import { Group, Stack, Text } from '@mantine/core';
import { CopyTextButton } from '@/components/common/CopyIconButton';
import InfoRow from '@/components/common/InfoRow';

export interface RequisiteItem {
  readonly label: string;
  readonly value?: string;
  /** Машинный идентификатор (ИНН, КПП, ОГРН, коды): значение — моноширинным IdText. */
  readonly mono?: boolean;
}

interface RequisitesBlockProps {
  readonly title: string;
  readonly items: readonly RequisiteItem[];
  /** Если задан — показать «Скопировать всё» (копирует видимые строки блоком «подпись: значение»). */
  readonly copyAllLabel?: string;
  /** Строки в начало копии, которые НЕ отображаются в блоке (напр. название организации). */
  readonly copyLeadLines?: readonly string[];
}

// Блок реквизитов: подпись секции + строки «подпись: значение» (пустые скрыты) + опц. «Скопировать всё».
// Реестр часто передают третьим лицам — отсюда копирование целым блоком. Хром (Card) — на стороне вызова.
export default function RequisitesBlock({ title, items, copyAllLabel, copyLeadLines }: RequisitesBlockProps) {
  const visible = items.filter((item) => Boolean(item.value));
  const copyText = [...(copyLeadLines ?? []), ...visible.map((item) => `${item.label}: ${item.value}`)]
    .filter(Boolean)
    .join('\n');

  return (
    <Stack gap="xs">
      {/* wrap: на узком экране кнопка «Скопировать всё» переносится под длинный заголовок, а не обрезается. */}
      <Group justify="space-between" wrap="wrap" gap="xs">
        <Text c="gray.6" size="xs" tt="uppercase" fw={600} style={{ minWidth: 0 }}>
          {title}
        </Text>
        {copyAllLabel ? <CopyTextButton value={copyText} label={copyAllLabel} /> : null}
      </Group>
      {visible.map((item) => (
        <InfoRow key={item.label} label={item.label} value={item.value} mono={item.mono} />
      ))}
    </Stack>
  );
}
